export default __webpack_public_path__ + "static/media/paris.85e06ed0.jpg";